import { useState } from "react";
import { http } from "@/lib/api";
import { toast } from "sonner";
import { Modal } from "./AdminShared";

export default function LocationModal({ loc, onClose, onSaved }) {
  const isNew = !loc.id;
  const [form, setForm] = useState(loc);
  const [saving, setSaving] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      const body = { ...form }; delete body.id; delete body.created_at; delete body._id;
      if (isNew) await http.post("/locations", body); else await http.put(`/locations/${loc.id}`, body);
      toast.success("Saved."); onSaved();
    } catch { toast.error("Save failed."); }
    finally { setSaving(false); }
  };
  return (
    <Modal title={isNew ? "New Location" : "Edit Location"} onClose={onClose}>
      <form onSubmit={submit} className="space-y-3">
        <input required placeholder="Business Name" value={form.business_name} onChange={e => setForm({...form, business_name: e.target.value})} className="stc-input"/>
        <input required placeholder="Location Name" value={form.location_name} onChange={e => setForm({...form, location_name: e.target.value})} className="stc-input"/>
        <input placeholder="Address" value={form.address} onChange={e => setForm({...form, address: e.target.value})} className="stc-input"/>
        <div className="grid grid-cols-2 gap-3">
          <input placeholder="Contact Person" value={form.contact_person} onChange={e => setForm({...form, contact_person: e.target.value})} className="stc-input"/>
          <input placeholder="Contact Email" type="email" value={form.contact_email} onChange={e => setForm({...form, contact_email: e.target.value})} className="stc-input"/>
        </div>
        <textarea placeholder="Notes" rows={3} value={form.notes} onChange={e => setForm({...form, notes: e.target.value})} className="stc-input font-body"/>
        <label className="flex items-center gap-2 text-[#F4F1EA] text-sm"><input type="checkbox" className="accent-[#C9A055]" checked={form.active} onChange={e => setForm({...form, active: e.target.checked})}/> Active</label>
        <div className="flex justify-end gap-3 pt-3 border-t border-white/10">
          <button type="button" onClick={onClose} className="btn-outline">Cancel</button>
          <button disabled={saving} className="btn-gold">{saving ? "Saving…" : "Save"}</button>
        </div>
      </form>
    </Modal>
  );
}
